import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-6d69d30f")
const _hoisted_1 = {
  key: 0,
  class: "page"
}
const _hoisted_2 = { class: "detail-grid" }
const _hoisted_3 = { class: "detail-item" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, "ID Richiesta", -1)
const _hoisted_5 = { class: "value" }
const _hoisted_6 = { class: "detail-item" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, "Stato", -1)
const _hoisted_8 = { class: "value" }
const _hoisted_9 = { class: "status-with-action" }
const _hoisted_10 = { class: "detail-item" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", null, "Dimensione Pacco", -1)
const _hoisted_12 = { class: "value" }
const _hoisted_13 = { class: "detail-item" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", null, "Prezzo Offerto", -1)
const _hoisted_15 = { class: "value" }
const _hoisted_16 = { class: "detail-item" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", null, "Data Creazione", -1)
const _hoisted_18 = { class: "value" }
const _hoisted_19 = { class: "detail-item" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", null, "Massimo Ritiro", -1)
const _hoisted_21 = { class: "value" }
const _hoisted_22 = { class: "detail-item" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", null, "Massima Consegna", -1)
const _hoisted_24 = { class: "value" }
const _hoisted_25 = {
  key: 0,
  class: "detail-item"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", null, "Codice QR Ritiro", -1)
const _hoisted_27 = { class: "value" }
const _hoisted_28 = {
  key: 1,
  class: "detail-item"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", null, "Codice QR Consegna", -1)
const _hoisted_30 = { class: "value" }
const _hoisted_31 = { class: "detail-grid" }
const _hoisted_32 = { class: "detail-item" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", null, "Nome", -1)
const _hoisted_34 = { class: "value" }
const _hoisted_35 = { class: "detail-item" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", null, "Email", -1)
const _hoisted_37 = { class: "value" }
const _hoisted_38 = {
  key: 0,
  class: "detail-item"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", null, "Ragione Sociale", -1)
const _hoisted_40 = { class: "value" }
const _hoisted_41 = {
  key: 1,
  class: "detail-item"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", null, "P.IVA", -1)
const _hoisted_43 = { class: "value" }
const _hoisted_44 = { class: "detail-item" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", null, "Rating", -1)
const _hoisted_46 = { class: "value" }
const _hoisted_47 = { class: "rating-display" }
const _hoisted_48 = { class: "rating-number" }
const _hoisted_49 = { class: "detail-grid" }
const _hoisted_50 = { class: "detail-item" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", null, "Nome", -1)
const _hoisted_52 = { class: "value" }
const _hoisted_53 = { class: "detail-item" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("label", null, "Email", -1)
const _hoisted_55 = { class: "value" }
const _hoisted_56 = { class: "detail-item" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", null, "Rating", -1)
const _hoisted_58 = { class: "value" }
const _hoisted_59 = { class: "rating-display" }
const _hoisted_60 = { class: "rating-number" }
const _hoisted_61 = {
  key: 0,
  class: "detail-item"
}
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", null, "Prezzo Offerta Accettata", -1)
const _hoisted_63 = { class: "value" }
const _hoisted_64 = {
  key: 0,
  class: "p-mt-3"
}
const _hoisted_65 = /*#__PURE__*/_createElementVNode("label", null, "Note Autista", -1)
const _hoisted_66 = { class: "value" }
const _hoisted_67 = { class: "detail-grid" }
const _hoisted_68 = { class: "detail-item" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("label", null, "Nome Contatto", -1)
const _hoisted_70 = { class: "value" }
const _hoisted_71 = { class: "detail-item" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("label", null, "Telefono", -1)
const _hoisted_73 = { class: "value" }
const _hoisted_74 = { class: "detail-item" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("label", null, "Indirizzo", -1)
const _hoisted_76 = { class: "value" }
const _hoisted_77 = { class: "detail-item" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("label", null, "Città", -1)
const _hoisted_79 = { class: "value" }
const _hoisted_80 = { class: "detail-item" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("label", null, "Provincia", -1)
const _hoisted_82 = { class: "value" }
const _hoisted_83 = { class: "detail-item" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("label", null, "CAP", -1)
const _hoisted_85 = { class: "value" }
const _hoisted_86 = { class: "detail-item" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("label", null, "Coordinate", -1)
const _hoisted_88 = { class: "value" }
const _hoisted_89 = {
  key: 0,
  class: "p-mt-3"
}
const _hoisted_90 = /*#__PURE__*/_createElementVNode("label", null, "Note Ritiro", -1)
const _hoisted_91 = { class: "value" }
const _hoisted_92 = { class: "detail-grid" }
const _hoisted_93 = { class: "detail-item" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("label", null, "Nome Contatto", -1)
const _hoisted_95 = { class: "value" }
const _hoisted_96 = { class: "detail-item" }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("label", null, "Telefono", -1)
const _hoisted_98 = { class: "value" }
const _hoisted_99 = { class: "detail-item" }
const _hoisted_100 = /*#__PURE__*/_createElementVNode("label", null, "Indirizzo", -1)
const _hoisted_101 = { class: "value" }
const _hoisted_102 = { class: "detail-item" }
const _hoisted_103 = /*#__PURE__*/_createElementVNode("label", null, "Città", -1)
const _hoisted_104 = { class: "value" }
const _hoisted_105 = { class: "detail-item" }
const _hoisted_106 = /*#__PURE__*/_createElementVNode("label", null, "Provincia", -1)
const _hoisted_107 = { class: "value" }
const _hoisted_108 = { class: "detail-item" }
const _hoisted_109 = /*#__PURE__*/_createElementVNode("label", null, "CAP", -1)
const _hoisted_110 = { class: "value" }
const _hoisted_111 = { class: "detail-item" }
const _hoisted_112 = /*#__PURE__*/_createElementVNode("label", null, "Coordinate", -1)
const _hoisted_113 = { class: "value" }
const _hoisted_114 = {
  key: 0,
  class: "p-mt-3"
}
const _hoisted_115 = /*#__PURE__*/_createElementVNode("label", null, "Note Consegna", -1)
const _hoisted_116 = { class: "value" }
const _hoisted_117 = { key: 0 }
const _hoisted_118 = { key: 1 }
const _hoisted_119 = { key: 0 }
const _hoisted_120 = { key: 1 }
const _hoisted_121 = { class: "review-header" }
const _hoisted_122 = /*#__PURE__*/_createTextVNode(" ha recensito ")
const _hoisted_123 = { class: "rating-display" }
const _hoisted_124 = { class: "rating-number" }
const _hoisted_125 = {
  key: 0,
  class: "review-comment"
}
const _hoisted_126 = { class: "review-date" }
const _hoisted_127 = {
  key: 1,
  class: "page"
}
const _hoisted_128 = {
  key: 2,
  class: "page"
}
const _hoisted_129 = /*#__PURE__*/_createTextVNode("Richiesta non trovata")
const _hoisted_130 = { class: "p-fluid" }
const _hoisted_131 = { class: "p-field p-mb-3" }
const _hoisted_132 = /*#__PURE__*/_createElementVNode("label", { for: "cancelMessage" }, "Messaggio", -1)
const _hoisted_133 = { class: "p-field-checkbox" }
const _hoisted_134 = /*#__PURE__*/_createElementVNode("label", { for: "cancelRefund" }, "Effettua rimborso", -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackButton = _resolveComponent("BackButton")!
  const _component_PageHeader = _resolveComponent("PageHeader")!
  const _component_Tag = _resolveComponent("Tag")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DateFormatted = _resolveComponent("DateFormatted")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_Rating = _resolveComponent("Rating")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_Message = _resolveComponent("Message")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.request)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_PageHeader, {
            showDelete: false,
            showSave: false,
            title: `Dettaglio Richiesta #${_ctx.request.id}`
          }, {
            actions: _withCtx(() => [
              _createVNode(_component_BackButton)
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(_component_Panel, {
            header: "Informazioni Generali",
            class: "p-mb-3"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _hoisted_4,
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.request.id), 1)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_Tag, {
                        value: _ctx.getStatusLabel(_ctx.request.status),
                        severity: _ctx.getStatusSeverity(_ctx.request.status)
                      }, null, 8, ["value", "severity"]),
                      (_ctx.canCancel)
                        ? (_openBlock(), _createBlock(_component_Button, {
                            key: 0,
                            label: "Annulla richiesta",
                            icon: "pi pi-times",
                            class: "p-button-danger p-button-sm",
                            onClick: _ctx.openCancelDialog
                          }, null, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_Tag, {
                      value: _ctx.getPackageSizeLabel(_ctx.request.package_size),
                      severity: "info"
                    }, null, 8, ["value"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.formatAmount(_ctx.request.price_offered)), 1)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_DateFormatted, {
                      date: _ctx.request.created_at,
                      format: "DD/MM/YYYY HH:mm"
                    }, null, 8, ["date"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_DateFormatted, {
                      date: _ctx.request.max_pickup_datetime,
                      format: "DD/MM/YYYY HH:mm"
                    }, null, 8, ["date"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_DateFormatted, {
                      date: _ctx.request.max_delivery_datetime,
                      format: "DD/MM/YYYY HH:mm"
                    }, null, 8, ["date"])
                  ])
                ]),
                (_ctx.request.qr_pickup_code)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _hoisted_26,
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("code", null, _toDisplayString(_ctx.request.qr_pickup_code), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.request.qr_delivery_code)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      _hoisted_29,
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("code", null, _toDisplayString(_ctx.request.qr_delivery_code), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }),
          (_ctx.request.entity)
            ? (_openBlock(), _createBlock(_component_Panel, {
                key: 0,
                header: "Cliente",
                class: "p-mb-3"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _hoisted_33,
                      _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.getEntityName(_ctx.request.entity)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _hoisted_36,
                      _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.request.entity.email), 1)
                    ]),
                    (_ctx.request.entity.business_name)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                          _hoisted_39,
                          _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.request.entity.business_name), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.request.entity.vat)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                          _hoisted_42,
                          _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.request.entity.vat), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_44, [
                      _hoisted_45,
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("div", _hoisted_47, [
                          _createVNode(_component_Rating, {
                            modelValue: _ctx.request.entity.rating_avg,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.request.entity.rating_avg = $event)),
                            readonly: "",
                            cancel: false,
                            stars: 5
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("span", _hoisted_48, "(" + _toDisplayString(_ctx.request.entity.rating_avg?.toFixed(1) || '0.0') + ")", 1)
                        ])
                      ])
                    ])
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.request.assigned_driver_entity)
            ? (_openBlock(), _createBlock(_component_Panel, {
                key: 1,
                header: "Autista Assegnato",
                class: "p-mb-3"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, [
                      _hoisted_51,
                      _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.getEntityName(_ctx.request.assigned_driver_entity)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_53, [
                      _hoisted_54,
                      _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.request.assigned_driver_entity.email), 1)
                    ]),
                    _createElementVNode("div", _hoisted_56, [
                      _hoisted_57,
                      _createElementVNode("div", _hoisted_58, [
                        _createElementVNode("div", _hoisted_59, [
                          _createVNode(_component_Rating, {
                            modelValue: _ctx.request.assigned_driver_entity.rating_avg,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.request.assigned_driver_entity.rating_avg = $event)),
                            readonly: "",
                            cancel: false,
                            stars: 5
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("span", _hoisted_60, "(" + _toDisplayString(_ctx.request.assigned_driver_entity.rating_avg?.toFixed(1) || '0.0') + ")", 1)
                        ])
                      ])
                    ]),
                    (_ctx.request.driver_offer)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                          _hoisted_62,
                          _createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.formatAmount(_ctx.request.driver_offer.price_offered)), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.request.driver_offer?.driver_notes)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                        _hoisted_65,
                        _createElementVNode("div", _hoisted_66, _toDisplayString(_ctx.request.driver_offer.driver_notes), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_Panel, {
            header: "Informazioni Ritiro",
            class: "p-mb-3"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_67, [
                _createElementVNode("div", _hoisted_68, [
                  _hoisted_69,
                  _createElementVNode("div", _hoisted_70, _toDisplayString(_ctx.request.pickup_name), 1)
                ]),
                _createElementVNode("div", _hoisted_71, [
                  _hoisted_72,
                  _createElementVNode("div", _hoisted_73, _toDisplayString(_ctx.request.pickup_phone), 1)
                ]),
                _createElementVNode("div", _hoisted_74, [
                  _hoisted_75,
                  _createElementVNode("div", _hoisted_76, _toDisplayString(_ctx.request.pickup_address), 1)
                ]),
                _createElementVNode("div", _hoisted_77, [
                  _hoisted_78,
                  _createElementVNode("div", _hoisted_79, _toDisplayString(_ctx.request.pickup_city), 1)
                ]),
                _createElementVNode("div", _hoisted_80, [
                  _hoisted_81,
                  _createElementVNode("div", _hoisted_82, _toDisplayString(_ctx.request.pickup_province), 1)
                ]),
                _createElementVNode("div", _hoisted_83, [
                  _hoisted_84,
                  _createElementVNode("div", _hoisted_85, _toDisplayString(_ctx.request.pickup_zipcode), 1)
                ]),
                _createElementVNode("div", _hoisted_86, [
                  _hoisted_87,
                  _createElementVNode("div", _hoisted_88, _toDisplayString(_ctx.request.pickup_lat) + ", " + _toDisplayString(_ctx.request.pickup_lng), 1)
                ])
              ]),
              (_ctx.request.pickup_notes)
                ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                    _hoisted_90,
                    _createElementVNode("div", _hoisted_91, _toDisplayString(_ctx.request.pickup_notes), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_Panel, {
            header: "Informazioni Consegna",
            class: "p-mb-3"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_92, [
                _createElementVNode("div", _hoisted_93, [
                  _hoisted_94,
                  _createElementVNode("div", _hoisted_95, _toDisplayString(_ctx.request.delivery_name), 1)
                ]),
                _createElementVNode("div", _hoisted_96, [
                  _hoisted_97,
                  _createElementVNode("div", _hoisted_98, _toDisplayString(_ctx.request.delivery_phone), 1)
                ]),
                _createElementVNode("div", _hoisted_99, [
                  _hoisted_100,
                  _createElementVNode("div", _hoisted_101, _toDisplayString(_ctx.request.delivery_address), 1)
                ]),
                _createElementVNode("div", _hoisted_102, [
                  _hoisted_103,
                  _createElementVNode("div", _hoisted_104, _toDisplayString(_ctx.request.delivery_city), 1)
                ]),
                _createElementVNode("div", _hoisted_105, [
                  _hoisted_106,
                  _createElementVNode("div", _hoisted_107, _toDisplayString(_ctx.request.delivery_province), 1)
                ]),
                _createElementVNode("div", _hoisted_108, [
                  _hoisted_109,
                  _createElementVNode("div", _hoisted_110, _toDisplayString(_ctx.request.delivery_zipcode), 1)
                ]),
                _createElementVNode("div", _hoisted_111, [
                  _hoisted_112,
                  _createElementVNode("div", _hoisted_113, _toDisplayString(_ctx.request.delivery_lat) + ", " + _toDisplayString(_ctx.request.delivery_lng), 1)
                ])
              ]),
              (_ctx.request.delivery_notes)
                ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
                    _hoisted_115,
                    _createElementVNode("div", _hoisted_116, _toDisplayString(_ctx.request.delivery_notes), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (_ctx.request.offers && _ctx.request.offers.length > 0)
            ? (_openBlock(), _createBlock(_component_Panel, {
                key: 2,
                header: "Offerte Ricevute",
                class: "p-mb-3",
                collapsed: true,
                toggleable: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DataTable, {
                    value: _ctx.request.offers,
                    responsiveLayout: "scroll"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Column, {
                        field: "id",
                        header: "ID",
                        sortable: ""
                      }),
                      _createVNode(_component_Column, {
                        header: "Autista",
                        sortable: ""
                      }, {
                        body: _withCtx(({data}) => [
                          (data.driver_entity)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_117, _toDisplayString(_ctx.getEntityName(data.driver_entity)), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "price_offered",
                        header: "Prezzo Offerto",
                        sortable: ""
                      }, {
                        body: _withCtx(({data}) => [
                          _createTextVNode(_toDisplayString(_ctx.formatAmount(data.price_offered)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "status",
                        header: "Stato",
                        sortable: ""
                      }, {
                        body: _withCtx(({data}) => [
                          _createVNode(_component_Tag, {
                            value: _ctx.getOfferStatusLabel(data.status),
                            severity: _ctx.getOfferStatusSeverity(data.status)
                          }, null, 8, ["value", "severity"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "created_at",
                        header: "Data Offerta",
                        sortable: ""
                      }, {
                        body: _withCtx(({data}) => [
                          _createVNode(_component_DateFormatted, {
                            date: data.created_at,
                            format: "DD/MM/YYYY HH:mm"
                          }, null, 8, ["date"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "decision_at",
                        header: "Data Decisione",
                        sortable: ""
                      }, {
                        body: _withCtx(({data}) => [
                          (data.decision_at)
                            ? (_openBlock(), _createBlock(_component_DateFormatted, {
                                key: 0,
                                date: data.decision_at,
                                format: "DD/MM/YYYY HH:mm"
                              }, null, 8, ["date"]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_118, "-"))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "driver_notes",
                        header: "Note"
                      }, {
                        body: _withCtx(({data}) => [
                          (data.driver_notes)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_119, _toDisplayString(data.driver_notes), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_120, "-"))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.request.reviews && _ctx.request.reviews.length > 0)
            ? (_openBlock(), _createBlock(_component_Panel, {
                key: 3,
                header: "Recensioni",
                class: "p-mb-3",
                collapsed: true,
                toggleable: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.request.reviews, (review) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: review.id,
                      class: "review-item p-mb-3"
                    }, [
                      _createElementVNode("div", _hoisted_121, [
                        _createElementVNode("div", null, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.getEntityName(review.reviewer_entity)), 1),
                          _hoisted_122,
                          _createElementVNode("strong", null, _toDisplayString(_ctx.getEntityName(review.reviewed_entity)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_123, [
                          _createVNode(_component_Rating, {
                            modelValue: review.rating,
                            "onUpdate:modelValue": ($event: any) => (review.rating = $event),
                            readonly: "",
                            cancel: false,
                            stars: 5
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                          _createElementVNode("span", _hoisted_124, "(" + _toDisplayString(review.rating) + ")", 1)
                        ])
                      ]),
                      (review.comment)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_125, _toDisplayString(review.comment), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_126, [
                        _createVNode(_component_DateFormatted, {
                          date: review.created_at,
                          format: "DD/MM/YYYY HH:mm"
                        }, null, 8, ["date"])
                      ])
                    ]))
                  }), 128))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.request.billing_info)
            ? (_openBlock(), _createBlock(_component_Panel, {
                key: 4,
                header: "Dati di Fatturazione",
                class: "p-mb-3",
                collapsed: true,
                toggleable: ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("pre", null, _toDisplayString(JSON.stringify(_ctx.request.billing_info, null, 2)), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]))
      : (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
            _createVNode(_component_ProgressSpinner)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_128, [
            _createVNode(_component_Message, { severity: "error" }, {
              default: _withCtx(() => [
                _hoisted_129
              ]),
              _: 1
            })
          ])),
    _createVNode(_component_Dialog, {
      visible: _ctx.showCancelDialog,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => (_ctx.showCancelDialog = $event)),
      header: "Annulla Richiesta",
      modal: true,
      closable: !_ctx.cancelling,
      style: {width: '500px'}
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Annulla",
          icon: "pi pi-times",
          class: "p-button-text",
          onClick: _ctx.closeCancelDialog,
          disabled: _ctx.cancelling
        }, null, 8, ["onClick", "disabled"]),
        _createVNode(_component_Button, {
          label: "Conferma Annullamento",
          icon: "pi pi-check",
          class: "p-button-danger",
          onClick: _ctx.confirmCancel,
          loading: _ctx.cancelling
        }, null, 8, ["onClick", "loading"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_130, [
          _createElementVNode("div", _hoisted_131, [
            _hoisted_132,
            _createVNode(_component_Textarea, {
              id: "cancelMessage",
              modelValue: _ctx.cancelMessage,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.cancelMessage = $event)),
              rows: "4",
              placeholder: "Inserisci un messaggio (opzionale)",
              disabled: _ctx.cancelling
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_133, [
            _createVNode(_component_Checkbox, {
              id: "cancelRefund",
              modelValue: _ctx.cancelRefund,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.cancelRefund = $event)),
              binary: true,
              disabled: _ctx.cancelling
            }, null, 8, ["modelValue", "disabled"]),
            _hoisted_134
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "closable"])
  ]))
}